export const detectAssetCategoryIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete asset category" || cleaned === "remove asset category") {
        return { intent: "delete_asset_category" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) asset category/);
    if (deleteMatch) {
        return { intent: "delete_asset_category", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create asset category") || cleaned.includes("add asset category")) {
        return { intent: "create_asset_category" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create asset category named (.+)/);
    if (createMatch) {
        return { intent: "create_asset_category", name: createMatch[1].trim() };
    }

    return null;
};
